/* unplugin-vue-components disabled */import { render } from "./checkout.vue?vue&type=template&id=32671cd5"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"

import "./checkout.vue?vue&type=style&index=0&id=32671cd5&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__